// =====================================================
// 📁 QuotationEmptySelectedProducts.tsx
// =====================================================

import { FileText } from 'lucide-react';

const QuotationEmptySelectedProducts = () => {
  return (
    <div
      className="
      flex
      items-center
      justify-center

      rounded-2xl

      border
      border-dashed
      border-stroke

      bg-whiter

      p-8

      shadow-1

      dark:border-strokedark
      dark:bg-boxdark
    "
    >
      <div className="text-center">
        {/* ===================================================== */}
        {/* 🔹 Icon */}
        {/* ===================================================== */}
        <div
          className="
          mx-auto

          flex
          h-18
          w-18
          items-center
          justify-center

          rounded-2xl

          border
          border-primary/10

          bg-primary/10

          text-primary

          shadow-sm
        "
        >
          <FileText size={34} />
        </div>

        {/* ===================================================== */}
        {/* 🔹 Title */}
        {/* ===================================================== */}
        <h3
          className="
          mt-5

          text-lg
          font-semibold

          text-black

          dark:text-white
        "
        >
          No hay productos cotizados
        </h3>

        {/* ===================================================== */}
        {/* 🔹 Description */}
        {/* ===================================================== */}
        <p
          className="
          mx-auto
          mt-2

          max-w-[320px]

          text-sm
          leading-relaxed

          text-body

          dark:text-bodydark1
        "
        >
          Agrega productos desde el panel izquierdo para comenzar la cotización.
        </p>
      </div>
    </div>
  );
};

export default QuotationEmptySelectedProducts;
